import React, { useEffect, useState } from "react";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import SDCFilters from "./SDCFilters";
import SDCList from "./SDCList";

const SDCRegister = () => {
  const [SDCData, setSDCData] = useState([]);
  const [filteredSupplier, setFilteredSupplier] = useState("");
  const [filteredCivil, setFilteredCivil] = useState("");
  const [filteredMech, setFilteredMech] = useState("");
  const [filteredElec, setFilteredElec] = useState("");
  const [filteredUndergroundPipe, setFilteredUndergroundPipe] = useState("");
  const [filteredPackageSystem, setFilteredPackageSystem] = useState("");

  useEffect(() => {
    const getSDCData = async () => {
      try {
        const response = await axios.get(HOST_URL + `/api/getsdcdata`);
        // console.log("getsdcdata response =", response);
        const mySDCData = response.data;

        const mySDCArray = [];

        for (const key in mySDCData) {
          if (mySDCData[key].Status === "Approved")
            ///Un-comment this line to make just the "Approved" submitions pull through
            mySDCArray.push({
              id: key,
              companyName: mySDCData[key].Data.companyName,
              otherCompanyName: mySDCData[key].Data.otherCompanyNames,
              companyAddress: mySDCData[key].Data.companyAddress,
              companyPhone: mySDCData[key].Data.companyPhone,
              companyEmail: mySDCData[key].Data.companyEmail,
              companyLogo: mySDCData[key].LogoName,
              name: mySDCData[key].Data.name,
              supportedBy: mySDCData[key].Data.supportedBy,
              civilDesign: mySDCData[key].Data.competentCivilElements,
              otherCivil: mySDCData[key].Data.otherCivilElements,
              mechDesign: mySDCData[key].Data.competentMechanicalSystems,
              otherMech: mySDCData[key].Data.otherMechanicalSystems,
              elecDesign: mySDCData[key].Data.competentElectricalSystems,
              otherElec: mySDCData[key].Data.otherElectricalSystems,
              packageDesign: mySDCData[key].Data.competentPackageSystems,
              otherPackage: mySDCData[key].Data.otherPackageSystems,
              undergroundPipeline:
                mySDCData[key].Data.competentUndergroundPipeline,
              otherUndergroundPipeline:
                mySDCData[key].Data.otherUndergroundPipeline,
              dateOfLastReview: mySDCData[key].Data.dateOfLastReview,
            });
        }
        setSDCData(mySDCArray);
      } catch (error) {
        console.log(error);
      }
    };
    getSDCData();
  }, []);

  const saveSupplierEventHandler = (selectedSupplier) => {
    setFilteredSupplier(selectedSupplier);
  };

  const saveCivilEventHandler = (selectedCivil) => {
    setFilteredCivil(selectedCivil);
  };

  const saveMechEventHandler = (selectedMech) => {
    setFilteredMech(selectedMech);
  };

  const saveElecEventHandler = (selectedElec) => {
    setFilteredElec(selectedElec);
  };

  const saveUndergroundPipeEventHandler = (selectedUndergroundPipe) => {
    setFilteredUndergroundPipe(selectedUndergroundPipe);
  };

  const savePackageSystemEventHandler = (selectedPackageSystem) => {
    setFilteredPackageSystem(selectedPackageSystem);
  };

  return (
    <>
      {/* THIS IS THE START OF THE PAGE MODAL SECTION */}
      <div
        className="modal modal-page fade"
        id="SDCRegister"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="pageModalLabel"
        data-animation="false"
        key="SDCRegister_ModalPage"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="col-11">
                <h2 id="pageModalLabel" style={{ fontWeight: "bold" }}>
                  @one Alliance Design Competency Register
                </h2>
              </div>
              <div className="col-1">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  data-keyboard="true"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div className="modal-body">
              <div>
                {/* this is the DIV to change to make more use of the page*/}
                <div className="row">
                  <div className="col-3">
                    <h4>
                      This register holds details of all companies approved to
                      complete design work on behalf of the @one Alliance. The
                      capabilities of each company are listed.
                    </h4>
                    <h4>
                      You should only use a company for design work if they are
                      capable of completing the type of work required.
                    </h4>
                    <h4>
                      Please use the filters below to select the type of work
                      required. A series of cards will display on the right
                      showing all approved suppliers capable of completing that
                      type of work.
                    </h4>
                    <hr
                      style={{
                        color: "#6d7a80",
                        backgroundColor: "#6d7a80",
                        height: 2,
                        borderColor: "#6d7a80",
                      }}
                    ></hr>
                    <SDCFilters
                      SDCData={SDCData}
                      onSelectedSupplier={saveSupplierEventHandler}
                      onSelectedCivil={saveCivilEventHandler}
                      onSelectedMech={saveMechEventHandler}
                      onSelectedElec={saveElecEventHandler}
                      onSelectedUndergroundPipe={
                        saveUndergroundPipeEventHandler
                      }
                      onSelectedPackageSystem={savePackageSystemEventHandler}
                      selectedSupplier={filteredSupplier}
                      selectedCivil={filteredCivil}
                      selectedMech={filteredMech}
                      selectedElec={filteredElec}
                      selectedUndergroundPipe={filteredUndergroundPipe}
                      selectedPackageSystem={filteredPackageSystem}
                    />
                  </div>
                  <div
                    className=" col-9"
                    style={{
                      borderLeft: "2px solid #6d7a80",
                    }}
                  >
                    <SDCList
                      SDCData={SDCData}
                      filteredSupplier={filteredSupplier}
                      filteredCivil={filteredCivil}
                      filteredMech={filteredMech}
                      filteredElec={filteredElec}
                      filteredUndergroundPipe={filteredUndergroundPipe}
                      filteredPackageSystem={filteredPackageSystem}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SDCRegister;
